export default __webpack_public_path__ + "static/media/notification-profile.c5431b17.svg";